export default __webpack_public_path__ + "static/img/och_power_racks.c366423.jpg";